import { CardComponent } from "./card";
import React from "react";
import "./discard.css";
const renderStackCard = (card, deck, index) => {
    const style = {
        transform: `translate(${index * 0.1}em, ${-index * 0.1}em) skew(3deg)`,
    };
    return React.createElement(CardComponent, { card: card, disableDrag: true, deck: deck, key: index, style: style });
};
export const Discard = (props) => {
    const deck = props.deck;
    const discard = deck.discard;
    if (discard.length === 0) {
        return null;
    }
    const stack = discard.map((card, index) => renderStackCard(card, deck, index));
    const style = {
        left: `${deck.position.x - 132}rem`,
        top: `${deck.position.y}rem`,
    };
    let className = "discard";
    if (props.shuffle) {
        className += " shuffle";
    }
    return (React.createElement("div", { className: className, style: style }, stack));
};
